import { cleanupExpiredTodos } from './cleanupExpiredTodos';

// Function to get current IST time
const getCurrentISTTime = () => {
  const now = new Date();
  // IST is UTC+5:30
  const istTime = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
  return istTime;
};

// Function to be called periodically (e.g., every hour) to check for expired todos
export const runScheduledCleanup = async () => {
  try {
    const istTime = getCurrentISTTime();
    
    // Check if it's between 12:00 AM and 12:10 AM IST
    const hours = istTime.getUTCHours();
    const minutes = istTime.getUTCMinutes();
    
    if (hours === 0 && minutes < 10) {
      const result = await cleanupExpiredTodos();
      return result;
    } else {
      // Cleanup not needed at this time
      return { success: true, cleanupNotNeeded: true };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Function to set up periodic cleanup checks
export const setupPeriodicCleanup = () => {
  // Check every 15 minutes for more frequent checks
  const CLEANUP_CHECK_INTERVAL = 15 * 60 * 1000; // 15 minutes
  
  const intervalId = setInterval(async () => {
    await runScheduledCleanup();
  }, CLEANUP_CHECK_INTERVAL);
  
  // Return cleanup function
  return () => {
    clearInterval(intervalId);
  };
};

// Function to manually trigger cleanup (for testing)
export const manualCleanup = async () => {
  return await cleanupExpiredTodos();
};
